import React, { memo, useState } from "react";
import styled from "styled-components/macro";
import { BiTrashAlt } from "react-icons/bi";
import FilterRow from "./components/FilterRow";
import { DefaultText } from "theme/GlobalElements";
import Button from "components/Button";
import { buttonType } from "components/Button/Button";
import { ActiveFilter, Filter, PageWithFilterType } from "./types";
import { batch, useDispatch } from "react-redux";
import { setActiveSortingType } from "features/category/categorySlice";
import { SortingType } from "pages/category/types";
import FilterPricing from "./components/FilterPricing";
import { setPage } from "features/pagination/paginationSlice";

interface FiltersProps {
  filters: Filter[];
  removeFiltersCB: () => void;
  activeFiltersCount: number;
  pageType: PageWithFilterType;
  fetchFN: (activeFilters: ActiveFilter[], page: number) => void;
}

const Filters: React.FC<FiltersProps> = ({
  filters,
  removeFiltersCB,
  activeFiltersCount,
  pageType,
  fetchFN,
}) => {
  const dispatch = useDispatch();
  const [reset, setReset] = useState(false);

  const removeAllFilters = () => {
    setReset(!reset);
    batch(() => {
      dispatch(setActiveSortingType(SortingType.priceasc));
      dispatch(setPage(1));
    });

    removeFiltersCB();
  };

  return (
    <FiltersContainer>
      <Top>
        <DefaultText fontSize={12} style={{ fontWeight: "bold" }}>
          ФИЛТРИ ({activeFiltersCount})
        </DefaultText>
        <RemoveFilters disabled={activeFiltersCount === 0}>
          <Button
            disabled={activeFiltersCount === 0}
            onClick={removeAllFilters}
            type={buttonType.dangerBtn}
          >
            <BiTrashAlt className="filter-remove" />
          </Button>
        </RemoveFilters>
      </Top>
      <FilterRows>
        <FilterPricing pageType={pageType} reset={reset} fetchFN={fetchFN} />
        {filters.map((filter, idx) => {
          return (
            <FilterRow
              pageType={pageType}
              key={idx}
              filter={filter}
              fetchFN={fetchFN}
            />
          );
        })}
      </FilterRows>
    </FiltersContainer>
  );
};

const FiltersContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
`;

const Top = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;

const RemoveFilters = styled.div<{ disabled: boolean }>`
  border-radius: 100%;
  display: flex;
  align-items: center;

  .filter-remove {
    width: 18px;
    height: 18px;
    fill: black;
  }

  &:hover {
    .filter-remove {
      fill: ${(props) => (props.disabled ? "" : "white")};
    }
  }
`;

const FilterRows = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
`;

export default memo(Filters);
